import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/BreadCrumbs.module.css";
import { MdKeyboardArrowRight } from "react-icons/md";
const BreadCrumbs = ({ routes }) => {
  return (
    <div className={styles.BreadCrumbContainer}>
      {routes.map((d, index) => (
        <div
          className={styles.BreadCrumbItems}
          key={index}
          style={{ color: "rgb(88, 102, 126)" }}
        >
          {routes.length - 1 === index ? (
            <p style={{ color: "black", whiteSpace: "nowrap" }}>{d.name}</p>
          ) : (
            <>
              <span>
                {" "}
                <Link
                  className={styles.BreadCrumbItem}
                  to={d.path}
                  style={{ color: "rgb(88, 102, 126)", whiteSpace: "nowrap" }}
                >
                  {d.name}
                </Link>
              </span>

              <MdKeyboardArrowRight size={20} className={styles.icon} />
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default BreadCrumbs;
